
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorway-pay-modulr",
      function () {
        return require("private-next-pages/motorway-pay-modulr.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorway-pay-modulr"])
      });
    }
  